import { fromJS } from "immutable";

import { orderActions } from "actions/orderActions.js";

const initialState = fromJS({
  isLoading: false,
  hasErrors: false,
  data: {
    buyplan_id: null,
    order_number: null,
    buyplan_state: null
  }
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case orderActions.startLoader:
      return state.set("isLoading", true);
    case orderActions.success:
      return state
        .merge({
          hasErrors: false,
          isLoading: false
        })
        .set("data", fromJS(payload.data));
    case orderActions.failure:
      return state
        .merge({
          hasErrors: true,
          isLoading: false
        })
        .set("data", fromJS(payload.data));
    default:
      return state;
  }
};
